var UpdateOrganizationModal;

import OrganizationFormModel from './organization_form_model.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default UpdateOrganizationModal = Vue.extend({
  components: {
    'OrganizationFormModel': OrganizationFormModel
  },
  props: {
    organization: {
      type: Object
    },
    profileSchema: {
      type: Object,
      required: true
    },
    editOrganizationEditorExtendClass: {
      type: [String, Array]
    },
    updateOrganizationFunc: {
      type: Function,
      required: true
    },
    action: {
      type: String
    }
  },
  data: function() {
    return {
      description: this.organization.description,
      name: this.organization.name,
      applicationStrategy: this.organization.application_strategy
    };
  },
  template: `<OrganizationFormModel :title='"编辑组织"'
                       :prosfileFields='profileSchema.fields'
                       :organization='organization'
                       :editOrganizationEditorExtendClass='editOrganizationEditorExtendClass'
                       :action='action'
                       @descriptionChanged='descriptionChanged'
                       @valueChange='doRequest'
                       ref="organizationFormModelRef">
</OrganizationFormModel>`,
  methods: {
    descriptionChanged: function(value) {
      return this.description = value;
    },
    doRequest: function(organization_attributes) {
      var data;
      data = this._getParams(organization_attributes);
      return Skylark.Libs.Ajax.put(`/admin/organizations/${this.organization.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: data,
        success: (data, xhr) => {
          newAlertify('编辑组织成功', {
            type: 'success'
          });
          this.$refs.organizationFormModelRef.close();
          return this.updateOrganizationFunc(data);
        },
        error: function(xhr) {
          return newAlertify('编辑组织失败，请重试', {
            type: 'error'
          });
        }
      });
    },
    _getParams: function(organization_attributes) {
      if (this.action === "edit_description") {
        return {
          organization: {
            description: organization_attributes.description
          }
        };
      } else if (this.action === "edit_profile") {
        return {
          organization: {
            profile_submission_attributes: organization_attributes.profile_submission_attributes
          }
        };
      }
    },
    _resetModal: function() {
      this.$refs.basicAttributesRef.reset();
      return this.$refs.editor.clearContent();
    }
  }
});
